import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M.545 8.182a.545.545 0 0 0 .546-.545c0-1.163.074-2.469.223-3.917a2.727 2.727 0 0 1 2.441-2.436 38.953 38.953 0 0 1 3.882-.193.545.545 0 1 0 0-1.091C6.3 0 4.97.066 3.647.199a3.818 3.818 0 0 0-3.419 3.41A39.816 39.816 0 0 0 0 7.637c0 .301.244.545.545.545ZM15.818.545c0 .302.244.546.546.546 1.299 0 2.593.064 3.881.193a2.727 2.727 0 0 1 2.442 2.436c.148 1.448.223 2.754.223 3.917a.545.545 0 1 0 1.09 0 39.82 39.82 0 0 0-.228-4.028 3.818 3.818 0 0 0-3.418-3.41A40.045 40.045 0 0 0 16.364 0a.545.545 0 0 0-.546.545ZM7.637 22.91a.545.545 0 1 1 0 1.091 40.04 40.04 0 0 1-3.99-.199 3.818 3.818 0 0 1-3.419-3.41A39.815 39.815 0 0 1 0 16.363a.545.545 0 0 1 1.091 0c0 1.163.074 2.469.223 3.917a2.728 2.728 0 0 0 2.441 2.436c1.289.129 2.583.193 3.882.193Zm15.818-7.091a.545.545 0 0 0-.545.545c0 1.163-.075 2.469-.223 3.917a2.728 2.728 0 0 1-2.442 2.436 38.975 38.975 0 0 1-3.881.193.545.545 0 1 0 0 1.091 40.04 40.04 0 0 0 3.99-.199 3.818 3.818 0 0 0 3.418-3.41A39.82 39.82 0 0 0 24 16.363a.545.545 0 0 0-.545-.545Zm-8.841-1.63 3.6 3.6c.283.283-.141.707-.424.424l-3.6-3.6a5.1 5.1 0 1 1 .424-.424ZM6.3 10.8a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m18.214 17.789-.177.177.177-.177Zm-.424.424-.177.177.177-.177Zm-3.6-3.6.176-.177-.166-.166-.177.156.167.187Zm.247-.247 3.6 3.6.354-.354-3.6-3.6-.354.354Zm3.6 3.6a.08.08 0 0 1 .019.025.019.019 0 0 1 .001.009.063.063 0 0 1-.02.036.063.063 0 0 1-.037.02.02.02 0 0 1-.008-.001.078.078 0 0 1-.026-.019l-.353.354a.54.54 0 0 0 .778 0 .54.54 0 0 0 0-.778l-.354.354Zm-.07.07-3.6-3.6-.354.354 3.6 3.6.353-.354Zm-3.944-3.61a4.831 4.831 0 0 1-3.222 1.225v.5a5.33 5.33 0 0 0 3.555-1.351l-.333-.374Zm-3.222 1.225a4.85 4.85 0 0 1-4.85-4.85h-.5a5.35 5.35 0 0 0 5.35 5.35v-.5Zm-4.85-4.85a4.85 4.85 0 0 1 4.85-4.85v-.5a5.35 5.35 0 0 0-5.35 5.35h.5Zm4.85-4.85a4.85 4.85 0 0 1 4.85 4.85h.5a5.35 5.35 0 0 0-5.35-5.35v.5Zm4.85 4.85a4.83 4.83 0 0 1-1.224 3.222l.374.332a5.331 5.331 0 0 0 1.35-3.554h-.5Zm-9.6 0a4.75 4.75 0 0 0 4.75 4.75v-.5a4.25 4.25 0 0 1-4.25-4.25h-.5Zm4.75 4.75a4.75 4.75 0 0 0 4.75-4.75h-.5a4.25 4.25 0 0 1-4.25 4.25v.5Zm4.75-4.75a4.75 4.75 0 0 0-4.75-4.75v.5a4.25 4.25 0 0 1 4.25 4.25h.5Zm-4.75-4.75a4.75 4.75 0 0 0-4.75 4.75h.5a4.25 4.25 0 0 1 4.25-4.25v-.5Z"
    }
  )
);
var SvgScanOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ScanOutlined_default = SvgScanOutlined;

export { ScanOutlined_default as default };
